import enUS from './GE';

export default {
	// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
	'en-US': enUS
}
